import { PersistencePort } from '@/data/ports/PersistencePort';
import { DataSnapshot } from '@/types/domain';

const DB = 'legaltech-db';
const STORE = 'snapshot';
const KEY = 'one';

function openDB(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB, 1);
    req.onupgradeneeded = () => req.result.createObjectStore(STORE);
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export const IndexedDBAdapter: PersistencePort = {
  name: 'indexeddb',
  async health() {
    try {
      const db = await openDB();
      db.close();
      return { ok: true };
    } catch (e: any) {
      return { ok: false, details: String(e) };
    }
  },
  async get() {
    const db = await openDB();
    return new Promise<DataSnapshot | null>((resolve, reject) => {
      const tx = db.transaction(STORE, 'readonly');
      const req = tx.objectStore(STORE).get(KEY);
      req.onsuccess = () => {
        resolve((req.result ?? null) as DataSnapshot | null);
        db.close();
      };
      req.onerror = () => {
        reject(req.error);
        db.close();
      };
    });
  },
  async put(data) {
    const db = await openDB();
    await new Promise<void>((resolve, reject) => {
      const tx = db.transaction(STORE, 'readwrite');
      tx.objectStore(STORE).put(data, KEY);
      tx.oncomplete = () => {
        db.close();
        resolve();
      };
      tx.onerror = () => {
        db.close();
        reject(tx.error);
      };
    });
  },
  async clear() {
    const db = await openDB();
    await new Promise<void>((resolve, reject) => {
      const tx = db.transaction(STORE, 'readwrite');
      tx.objectStore(STORE).delete(KEY);
      tx.oncomplete = () => {
        db.close();
        resolve();
      };
      tx.onerror = () => {
        db.close();
        reject(tx.error);
      };
    });
  },
};
